// extracted by mini-css-extract-plugin
export default {"nav":"DesktopNav_nav__dvM+f","navContent":"DesktopNav_navContent__ZlFeY","navSection":"DesktopNav_navSection__s1Fdi","logo":"DesktopNav_logo__2FFH7"};